import type { FC } from "react"

import PaymentTermsSection from "./PaymentTermsSection"

import { useGetAssociatedLocations } from "@/screens/Companies/hooks/useGetAssociatedLocations"
import { usePaymentTermsContext } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"

// The payment terms summary is shared context for every Accounting sub-tab, so it sits above them.
export const PaymentTermsSummary: FC<{ companyId: string }> = ({ companyId }) => {
  const { isCompanyVendor, isCompanyCustomer } = usePaymentTermsContext()
  const { associatedLocationList } = useGetAssociatedLocations({ companyId })

  const hasBillingLocation = associatedLocationList.some((location) => location.billing?.locationId)

  if ((!isCompanyVendor && !isCompanyCustomer) || !hasBillingLocation) return null

  return <PaymentTermsSection companyId={companyId} />
}
